<template>
    <!-- 플랫폼, 마이페이지 -->
    <div>
        <MypageSubTitle/>
        <!-- title_cont : E -->
        <!-- container : S -->
        <div class="ptc_container" :key="resetKey">
            <h3 class="form_tit first">기본 정보</h3>
            <div class="view_cont">
                <ul class="column col_4" v-for="(rowData, rowKey) in userField"
                    :key="rowKey">
                    <li
                            v-for="(data, key) in rowData"
                            :key="key"
                    >
                        <div class="label_txt">
                            <span>{{data.title}}</span>
                        </div>
                        <div class="view_data">
                            <p class="view_txt">{{data.key != 'passWord' ? userInfo?.[data.key] : "********"}}</p>
                            <button v-if="data.key == 'passWord'"
                                    type="button"
                                    class="sm_btn ml20"
                                    @click="pwChangeLayerPopupActive = true">변경
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <form @submit.prevent="userAdditionalEdit">
                <div class="form_tit_wrap">
                    <div class="left">
                        <h3 class="form_tit first">추가정보</h3>
                    </div>
                    <button type="submit" class="sm_btn" v-text="userAdditionalEditToggle ? '수정완료' : '수정'"></button>
                </div>
                <!-- 뷰 모드 -->
                <div class="view_cont" v-if="!userAdditionalEditToggle">
                    <ul class="column col_4"
                        v-for="(rowData, rowKey) in userAdditionalField"
                        :key="rowKey">
                        <li v-for="(data, key) in rowData"
                            :key="key">
                            <div class="label_txt">
                                <span>{{data.title}}</span>
                            </div>
                            <div v-if="data.key == 'companyCode'" class="view_data">
                                <p class="view_txt">
                                  {{sortedCompanyList.find(company => userAdditionalInfo[data.key] == company.value)?.text}}
                                </p>
                            </div>
                            <div v-else class="view_data">
                                <p class="view_txt"
                                   v-text="userAdditionalInfo[data.key] == null ? '' : userAdditionalInfo[data.key]"></p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 수정모드 -->
                <div class="view_cont" v-else>
                    <ul class="column col_4"
                        v-for="(rowData, rowKey) in userAdditionalField"
                        :key="rowKey">
                        <li v-for="(data, key) in rowData"
                            :key="key">
                            <div class="label_txt">
                                <span>{{data.title}}<em v-if="data.key != 'companyCode'">*</em></span>
                            </div>
                            <div v-if="data.key =='companyCode'" class="column_input">
                              <select
                                  :class="{'validation_error' : data.error}"
                                  v-model="userAdditionalInfo[data.key]"
                              >
                                <option v-for="(opt,index) in sortedCompanyList" :key="index" :value="opt.value"
                                >
                                  {{opt.text}}
                                </option>
                               </select>
                                <p class="validation_text" v-show="data.error" v-text="data.errorMsg"></p>
                            </div>
                            <div v-else class="column_input">
                                <input
                                        type="text"
                                        :disabled="data?.disabled"
                                        :class="{'validation_error' : data.error}"
                                        v-model="userAdditionalInfo[data.key]"
                                />
                                <p class="validation_text" v-show="data.error" v-text="data.errorMsg"></p>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
            <div class="form_tit_wrap">
                <div class="left">
                    <h3 class="form_tit first">API Key</h3>
                </div>
                <div class="right">
                  <button type="button" class="sm_btn" v-if="!isLocked" @click="downloadFile">
                    API Document 다운로드
                  </button>
                  <button type="submit" class="sm_btn" v-if="!isLocked" @click="issueApiKey">KEY 발급</button>
                </div>
            </div>
            <div class="view_cont api-key-container" :class="{ locked: isLocked }">
              <!-- 블러 오버레이 -->
              <div class="blur-overlay" :class="{ hidden: !isLocked }">
                <button class="btn_type1 unlock-btn" @click="unlockApiKey">
                  <i class="icon-lock"></i> API Key 확인
                </button>
              </div>
              
              <!-- 실제 콘텐츠 -->
              <ul class="column col_custom api-key-row" v-for="(apiKeyData, index) in apiKeyDataList" :key="index">
                <li style="flex: 0 0 30px;">
                  <div class="label_txt text-center">
                    <span>No.</span>
                  </div>
                  <div class="view_data">
                    <p class="view_txt text-center">{{ index+1 }}</p>
                  </div>
                </li>
                <li style="flex: 1 1 450px;">
                  <div class="label_txt">
                    <span>KEY</span>
                  </div>
                  <div class="view_data">
                    <p class="view_txt">{{ apiKeyData.key }}</p>
                    <button 
                      class="btn_icon" 
                      @click="copyToClipboard(apiKeyData.key)"
                      title="복사"
                    >
                      📋
                    </button>
                  </div>
                </li>
                <li style="flex: 1 1 300px;">
                  <div class="label_txt">
                    <span>메모</span>
                  </div>
                  <div class="view_data">
                    <textarea 
                      class="form-control" 
                      v-model="apiKeyData.note"
                      :disabled="!apiKeyData.active"
                      rows="2"
                      placeholder="메모를 입력하세요"
                    ></textarea>
                  </div>
                </li>
                <li style="flex: 0 0 180px;">
                  <div class="label_txt">
                    <span>발급일</span>
                  </div>
                  <div class="view_data">
                    <p class="view_txt">{{ toDateTimeLocal(apiKeyData.createdDate) }}</p>
                  </div>
                </li>
                <li style="flex: 0 0 180px;">
                  <div class="label_txt">
                    <span>최근 사용일</span>
                  </div>
                  <div class="view_data">
                    <p class="view_txt">{{ toDateTimeLocal(apiKeyData.lastAccessDate) }}</p>
                  </div>
                </li>
                <li style="flex: 0 0 180px;">
                  <div class="label_txt">
                    <span>만료일</span>
                  </div>
                  <div class="view_data">
                    <input 
                      type="datetime-local" 
                      class="form-control" 
                      :value="toDateTimeLocal(apiKeyData.expireDate)"
                      @input="apiKeyData.expireDate = fromDateTimeLocal($event.target.value)"
                      :disabled="!apiKeyData.active"
                    />
                  </div>
                </li>
                <li style="flex: 0 0 100px;" v-if="apiKeyData.active">
                  <div class="label_txt">
                    <span>Action</span>
                  </div>
                  <div class="view_data">
                    <button 
                      class="btn_type1"
                      style="margin-right: 3px"
                      @click="saveExpireDate(apiKeyData.id, apiKeyData.expireDate, apiKeyData.note)"
                      :disabled="isLocked"
                    >
                      저장
                    </button>
                    <button 
                      class="btn_type3" 
                      @click="deleteExpireDate(apiKeyData.id)"
                      :disabled="isLocked"
                    >
                      비활성화
                    </button>
                  </div>
                </li>
                <li v-else>
                  <div class="label_txt">
                    <span></span>
                  </div>
                  <div class="view_data">
                    <p class="view_txt">비활성화된 정보 입니다.</p>
                  </div>
                </li>
              </ul>
            </div>
        </div>
        <pwChangeLayerPopup
                :active="pwChangeLayerPopupActive"
                @close="closePwChangeLayerPopup"
        />
        <CommonInputModal ref="inputModal" />
        <Loading :visible="loading"></Loading>
    </div>
</template>

<script>
    import pwChangeLayerPopup from "@/components/modal/pwChangeLayerPopup";
    import CommonInputModal from '@/components/modal/CommonInputModal.vue';
    import MypageSubTitle from "@/views/Platform/Account/MypageSubTitle";
    import Loading from '@common/loading'
    import {createNamespacedHelpers} from 'vuex';
    const Hub = createNamespacedHelpers('Hub');
    export default {
        components: {
            pwChangeLayerPopup,
            MypageSubTitle,
            Loading,
            CommonInputModal,
        },
        data() {
            return {
                // 서버에서 가져온 데이터.
                userInfo: {},
                userAdditionalInfo: {},
                // 수정 모드용 변수.
                userAdditionalEditToggle: false,
                // 파일 저장시 사용되는 변수.
                pending: {
                    items: false,
                },
                // 사용할 데이터 필드
                userField: [
                    [
                        {key: "loginId", title: "아이디", validation: null},
                        {key: "name", title: "이름", validation: null},
                        {key: "email", title: "이메일", validation: null},
                        {key: "passWord", title: "비밀번호", validation: null},
                    ],
                ],
                userAdditionalField: [
                    [
                        {key: "mobile", title: "연락처", validation: "tel"},
                        {key: "companyCode", title: "소속(직장명)코드", validation: "required"},
                        {key: "companyPhone", title: "직장전화번호", validation: "required"},
                        {key: "position", title: "직책", validation: "required"},
                    ],
                    [
                        {key: "fax", title: "팩스", validation: null},
                    ]
                ],
                resetKey: 0,
                generalUser: false,
                pwChangeLayerPopupActive: false,
                loading: false,
                field: null,
                fieldArr: [{value: "", fieldList: []}, {value: "", fieldList: []}, {value: "", fieldList: []}, {
                  value: "",
                  fieldList: []
                }],
                fieldPathText: "",
                selectedFieldId: "",
                selectEndPoint : false,
                isLocked: true,
                apiKeyDataList: [{
                  id: 1,
                  key: '12345678-1234-1234-1234-123456789abc',
                  note: '여기서 사용하는 용도',
                  createdDate: '0000.01.01',
                  expireDate: '9999-12-31'
                }],
            };
        },
      computed: {
        user() {
          return this.$store.state.user;
        },
        sortedCompanyList() {
          const list = this.$store.getters["Hub/getOrgCodeArray"] || [];
          const sorted = [...list].sort((a, b) => a.text.localeCompare(b.text, "ko"));
          sorted.unshift({ value: "", text: "선택해주세요" });
          return sorted;
        },
      },
        watch: {
        },
        async mounted() {
            if (this.user && !this.user.admin && !this.user.assistant && !this.user.committee && !this.user.super && !this.user.generalManager) {
                this.generalUser = true;
            }
            await this.setData();
        },
        methods: {
            async setData() {
                this.loading = true;
                try {
                    this.resetInfoData("user");
                    this.resetInfoData("userAdditional");
                    const data = await this.$wApi.user.mypage.me();
                    if (!data.error) {
                        this.setInfoData("user", data);
                        this.setInfoData("userAdditional", data);
                    }
                    this.resetKey++;
                } catch (e) {
                    window.alert("데이터 로딩중 에러가 발생했습니다.");
                } finally {
                    this.loading = false;
                }
            },
            async userAdditionalEdit(e) {
                if (!this.userAdditionalEditToggle) {
                    return (this.userAdditionalEditToggle = true);
                }
                const checkValid = this.checkValidInfoData("userAdditional");
                if (checkValid) {
                    this.resetKey++;
                    return;
                }
                const response = await this.$wApi.user.mypage.edit.info(this.userAdditionalInfo);
                if (response) {
                    window.wToast("추가정보가 저장되었습니다.", {variant: "platform"});
                    this.userAdditionalEditToggle = false;
                }
                this.userAdditionalEditToggle = false;
                this.loading = true;

                this.resetInfoData("user");
                this.resetInfoData("userAdditional");
                const data = await this.$wApi.user.mypage.me();
                if (!data.error) {
                    this.setInfoData("user", data);
                    this.setInfoData("userAdditional", data);
                }
                this.resetKey++;
                this.loading = false;
            },

            closePwChangeLayerPopup() {
                this.pwChangeLayerPopupActive = false;
            },
            resetInfoData(name) {
                this[name + "Field"].forEach(rowData => rowData.forEach((field) => {
                    field.error = false;
                    field.errorMsg = "";
                    this[name + "Info"][field.key] = "";
                }));
            },
            checkValidInfoData(name) {
                let resultValid = false;
                this[name + "Field"].forEach(rowData => rowData.forEach((field) => {
                    if (field.validation) {
                        if (field.validation == "required" || field.validation == "email" || field.validation == "tel" || field.validation == "jumin") {
                            if ((!this[name + "Info"][field.key]) || (this[name + "Info"][field.key].length <= 0)) {
                                field.error = true;
                                field.errorMsg = "입력되지 않았습니다.";
                                resultValid = true;
                            } else {
                                field.error = false;
                                field.errorMsg = "";
                            }
                        }
                        if(field.validation == "email"){
                            if(!this.email_check(this[name + "Info"][field.key])){
                                field.error = true;
                                field.errorMsg = "이메일 형식에 맞게 입력해 주세요.";
                                resultValid = true;
                            }
                        }
                        if(field.validation == "tel"){
                            if(!this.tel_check(this[name + "Info"][field.key])){
                                field.error = true;
                                field.errorMsg = "전화번호를 형식에 맞게 입력해 주세요.(-포함)";
                                resultValid = true;
                            }
                        }
                        if(field.validation == "jumin"){
                            if(!this.jumin_check(this[name + "Info"][field.key])){
                                field.error = true;
                                field.errorMsg = "주민등록번호를 형식에 맞게 입력해 주세요.";
                                resultValid = true;
                            }
                        }
                    }
                }));
                return resultValid;
            },
            setInfoData(name, data) {
                this[name + "Field"].forEach(rowData => rowData.forEach((field) => {
                    this[name + "Info"][field.key] = data[field.key] != null ? data[field.key] : "";
                }));
            },
            //이메일 정규식 체크
            email_check(email) {
                const reg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
                return reg.test(email);
            },
            tel_check(telNumber) {
                const reg = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}/;
                return reg.test(telNumber);
            },
            jumin_check(jumin){
                const reg = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/;
                return reg.test(jumin);
            },
            async unlockApiKey() {
                const password = await this.$refs.inputModal.open({
                  title: '비밀번호 입력',
                  message: 'API Key를 확인하려면 비밀번호를 입력하세요.',
                  inputType: 'password',
                  label: '비밀번호',
                  placeholder: '비밀번호를 입력하세요'
                });
                this.loading = true;
                if(password == null) {
                    this.loading = false;
                    return;
                }
                const passwordConfirmResult = await this.$wApi.user.mypage.passwordConfirm({password:password});
                if(passwordConfirmResult.error){
                    this.loading = false;
                    await window.alert(passwordConfirmResult.message|| '비밀번호 확인 중 오류가 발생하였습니다.');
                    return;
                }else{
                  await this.setApiKeyList();
                  this.loading = false;
                }
            },
            async setApiKeyList(){
              const result = await this.$wApi.user.mypage.getApiKeyList();
              if(result?.error){
                this.loading = false;
                await window.alert(result.message|| 'API Key 조회 중 오류가 발생하였습니다.');
                return;
              }
              if(result?.length>0){
                this.apiKeyDataList = result;
              }else{
                this.apiKeyDataList = [];
              }
              this.isLocked = false;
            },
            async deleteExpireDate(id){
              if (this.isLocked) {
                  await window.alert('먼저 API Key를 확인해주세요.');
                  return;
              }
              const confirm = await window.confirm("이 API Key를 비활성화하시겠습니까?<br>비활성화 후 다시 활성화하려면 관리자에게 문의해 주세요.");
              if(confirm){
                this.loading = true;
                const result = await this.$wApi.user.mypage.deactivateApiKey({
                  id:id,
                });
                if(result?.error) {
                  this.loading = false;
                  await window.alert(result.message || 'API Key 비활성화 중 오류가 발생하였습니다.');
                }else{
                  this.loading = false;
                  await this.setApiKeyList();
                  await window.alert('완료되었습니다.');
                }
              }
            },
            async saveExpireDate(id, expireDate, note) {
              if (this.isLocked) {
                  await window.alert('먼저 API Key를 확인해주세요.');
                  return;
              }
              this.loading = true;
              const result = await this.$wApi.user.mypage.saveApiKey({
                id:id,
                expireDate:expireDate,
                note:note,
              });
              if(result?.error){
                this.loading = false;
                await window.alert(result.message|| 'API Key 저장 중 오류가 발생하였습니다.');
                return;
              }else{
                this.loading = false;
                await this.setApiKeyList();
                await window.alert('저장되었습니다.');
              }
            },
            // 기본 만료일시 계산 (1년 후 00:00:00, 로컬 타임존)
            getDefaultExpireDateTime() {
              const date = new Date();
              date.setFullYear(date.getFullYear() + 1);
              date.setHours(0, 0, 0, 0);
              
              // 로컬 타임존 기준으로 포맷
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              
              return `${year}-${month}-${day}T${hours}:${minutes}`;
            },
            // 만료일 + 메모 받기
            async issueApiKey() {
              const result = await this.$refs.inputModal.open({
                title: 'API Key 발급',
                message: '새로운 API Key를 발급합니다.',
                fields: [
                  {
                    name: 'expireDate',
                    type: 'datetime-local',
                    label: '만료일',
                    required: true,
                    defaultValue: this.getDefaultExpireDateTime(),
                  },
                  {
                    name: 'note',
                    type: 'textarea',
                    label: '메모',
                    placeholder: '메모를 입력하세요 (선택)',
                    rows: 4
                  }
                ]
              });
              
              if (result) {
                if(result.expireDate==null || result.expireDate == ""){
                  await window.alert("만료일을 입력해 주세요.");
                  return;
                }
                this.loading = true;
                const createApiKeyResult = await this.$wApi.user.mypage.createApiKey({
                  expireDate:result.expireDate,
                  note:result.note
                });
                if(createApiKeyResult?.error){
                  this.loading = false;
                  await window.alert(createApiKeyResult.message|| 'API Key 발급 중 오류가 발생하였습니다.');
                  return;
                }else{
                  this.loading = false;
                  await this.setApiKeyList();
                  await window.alert("API Key 발급에 성공하였습니다.");
                }
              }
            },
            toDateTimeLocal(localDateTime) {
              if (!localDateTime) return '';
              return localDateTime.substring(0, 16);
            },
            
            fromDateTimeLocal(dateTimeLocal) {
              if (!dateTimeLocal) return null;
              return dateTimeLocal + ':00';
            },
            async copyToClipboard(text) {
              try {
                // 최신 브라우저 (Clipboard API)
                await navigator.clipboard.writeText(text);
                alert('복사되었습니다.');
                // 또는 토스트가 있다면
                // window.wToast('복사되었습니다!', {variant: 'platform'});
              } catch (err) {
                // 구형 브라우저 또는 권한 없을 때 fallback
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                
                try {
                  document.execCommand('copy');
                  alert('복사되었습니다!');
                } catch (e) {
                  alert('복사에 실패했습니다.');
                }
                
                document.body.removeChild(textarea);
              }
            },
          downloadFile(){
            const link = document.createElement('a');
            link.href = "/m3dhub/tutorial/Hub_Api_Document.pdf";
            link.download = "Hub_Api_Document.pdf"; // 다운로드할 파일명
            link.click();
          },
        }
    };
</script>
<style scoped>
    .api-key-container {
      position: relative;
    }
    
    .col_custom {
      display: flex;
      gap: 15px;
      transition: filter 0.3s;
    }
    
    .col_custom > li {
      display: flex;
      flex-direction: column;
    }
    
    /* 블러 오버레이 */
    .blur-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      transition: opacity 0.3s, visibility 0.3s;
    }
    
    .blur-overlay.hidden {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
    
    .unlock-btn {
      padding: 15px 30px;
      font-size: 1.1em;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    /* 콘텐츠 블러 */
    .api-key-container.locked .col_custom {
      filter: blur(5px);
      user-select: none;
    }
    
    .view_data input[type="date"] {
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      width: 100%;
    }
    
    .view_data input:disabled,
    .view_data button:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
    .api-key-row {
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
    /* 모바일 대응 */
    @media (max-width: 768px) {
      .api-key-row {
        flex-direction: column;
        border-bottom: 1px solid #e0e0e0;
      }
      
      .api-key-row > li {
        flex: 1 1 auto !important;
        width: 100% !important;
        margin-bottom: 15px;
      }
      
      .api-key-row > li:last-child {
        margin-bottom: 0;
      }
      
      /* Action 버튼들 */
      .api-key-row .view_data button {
        width: 100%;
        margin-bottom: 5px;
      }
    }
</style>